<template>
    <pendo-page-footer v-if="!hideFooter">
        <div class="pendo-footer__main">
            <i18n-t
                keypath="pendoFooter.copyright.mainMessage"
                tag="div">
                <template #copyrightInfo>
                    <strong>{{ $t('pendoFooter.copyright.date', { date: new Date().getFullYear() }) }}</strong>
                </template>
            </i18n-t>
            <div>
                <pendo-divider
                    decorative
                    direction="vertical"
                    stroke="var(--palette-gray-40)"
                    height="12px"
                    width="24px" />
            </div>
            <ul class="pendo-footer__links">
                <li>
                    <a
                        href="https://www.pendo.io/legal/terms-of-service/"
                        target="_blank"
                        rel="noopener noreferrer">
                        {{ $t('Terms of Service') }}
                    </a>
                </li>
                <li aria-hidden="true">
                    <pendo-divider
                        decorative
                        direction="vertical"
                        stroke="var(--palette-gray-40)"
                        height="12px"
                        width="24px" />
                </li>
                <li>
                    <a
                        href="https://www.pendo.io/legal/privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer">
                        {{ $t('Privacy Policy') }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="pendo-footer__ping-info">
            <small
                v-if="isSuperUser"
                class="footer-ping-information">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="`https://github.com/pendo-io/pendo-appengine/commit/${pingInformation.revision}`">
                    {{ pingInformation.revision }}
                </a>
                deployed by {{ pingInformation.builtBy }} at {{ pingInformation.builtAt }}
            </small>
        </div>
    </pendo-page-footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { PendoDivider, PendoPageFooter } from '@pendo/components';

export default {
    name: 'PendoFooter',
    components: {
        PendoDivider,
        PendoPageFooter,
    },
    computed: {
        ...mapState({
            pingInformation: (state) => state.config.pingInformation,
        }),
        ...mapGetters({
            super: 'auth/isSuper',
            ops: 'auth/isOps',
        }),
        isSuperUser () {
            return this.super || this.ops;
        },
        hideFooter () {
            return this.$route.meta?.hideFooter;
        },
    },
};
</script>

<style lang="less" scoped>
.pendo-footer__main {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 16px;
}

.pendo-footer__links {
    display: flex;
    flex-direction: row;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
}

.footer-ping-information {
    a {
        word-break: break-all;
    }
}
</style>
